module.exports = __webpack_public_path__ + "img/jtb-avatar-7560.b7f896aa.jpg";